import { jsx } from 'react/jsx-runtime';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import styles from '../../styles/uitk-egds-mark.css';
import { classNames } from '../../utils/classnames/index.esm.js';
const getClassNameList = classNames.bind(styles);
const EGDSMarkFlag = props => {
  const {
    className,
    description,
    id,
    name
  } = props;
  const assetsBaseUrl = 'https://a.travel-assets.com/egds/marks/flags/';
  const svgName = `${name?.toLowerCase()}.svg`;
  const baseCssClass = 'uitk-mark';
  const flagCssClass = 'uitk-mark-flag';
  const cssClassNames = getClassNameList(baseCssClass, className, flagCssClass);
  if (!name) {
    console.error(`Uitk-Flag must have "name" prop`);
  }
  const buildUrl = () => `${assetsBaseUrl}${svgName}`;
  const alt = description || '';
  return jsx("img", {
    className: cssClassNames,
    alt: alt,
    src: buildUrl(),
    id: id
  });
};
EGDSMarkFlag.displayName = 'EGDSMarkFlag';
export { EGDSMarkFlag };